import sortBy from 'lodash/sortBy';
import map from 'lodash/map';
import merge from 'lodash/merge';
import logger from '../../../externals/bss-package-logger/js/logger';
/**
 * Main function used to generate ui description (layout.components)
 * and tagging description (layout.behaviour) financial data along with standard resultData.
 * @param res
 * @param elementType
 * @param brand
 * @param country
 * @param descriptionConfig
 * @param flowId
 * @param entityId
 * @param insuranceQuoteId
 * @param flowParams
 * @param location
 * @param isLocationBody
 */
export function parseRequest(_a) {
    var res = _a.res, elementType = _a.elementType, brand = _a.brand, country = _a.country, descriptionConfig = _a.descriptionConfig, flowId = _a.flowId, entityId = _a.entityId, insuranceQuoteId = _a.insuranceQuoteId, flowParams = _a.flowParams, location = _a.location, isLocationBody = _a.isLocationBody, productType = _a.productType, isCompareFinance = _a.isCompareFinance, origin = _a.origin, privateUrl = _a.privateUrl, initConfiguration = _a.initConfiguration, standalone = _a.standalone;
    var data = merge({}, res);
    logger.info('ControllerToolbox => function: parseRequest | Params: ', elementType, brand, country, data, descriptionConfig);
    var resultData = data.resultData, layout = data.layout, cfTexts = data.cfTexts;
    if ((!resultData || !layout) && !standalone) {
        return res;
    }
    if (productType === "")
        productType = null;
    var _b = prepareProducts(data.resultData, productType, standalone) || {}, defaultProductId = _b.defaultProductId, productPositions = _b.productPositions, allProductPositions = _b.allProductPositions;
    if ((descriptionConfig[elementType].uiDescription && resultData && layout) || (descriptionConfig[elementType].uiDescription && standalone)) {
        logger.info('ControllerToolbox => function: parseRequest', resultData, productPositions, elementType);
        var envUrl = "".concat(process.env.ENV_URL);
        var signomUrl = "".concat(process.env.ENV_SIGNOM_URL);
        var uiDescOptions = {
            entityId: entityId,
            productPositions: productPositions,
            resultData: resultData,
            flowId: flowId,
            brand: brand,
            elementType: elementType,
            country: country,
            productIds: productPositions ? ['general'].concat(productPositions) : ['general'],
            applicationHost: envUrl.replace(/^https?:\/\//, ''),
            signomUrl: signomUrl,
            defaultProductId: defaultProductId,
            insuranceQuoteId: insuranceQuoteId,
            flowParams: flowParams,
            location: location,
            isLocationBody: isLocationBody,
            isCompareFinance: isCompareFinance,
            privateUrl: privateUrl,
            cfTexts: cfTexts,
            initConfiguration: initConfiguration,
            standalone: standalone
        };
        var layoutComponents = descriptionConfig[elementType].uiDescription(uiDescOptions);
        logger.info('ControllerToolbox => function: parseRequest | Params: ', 'ui', descriptionConfig[elementType].uiDescription, uiDescOptions, layoutComponents, resultData, productPositions, allProductPositions);
        layout.components = layoutComponents;
    }
    if (descriptionConfig[elementType].taggingDescription &&
        resultData &&
        layout) {
        var taggingDescOptions = {
            entityId: entityId,
            resultData: resultData,
            productPositions: productPositions,
            brand: brand,
            elementType: elementType,
            country: country,
        };
        var layoutBehaviour = descriptionConfig[elementType].taggingDescription(taggingDescOptions);
        logger.info('ControllerToolbox => function: parseRequest taggingDescription', resultData, taggingDescOptions, layoutBehaviour);
        layout.behaviour = layoutBehaviour;
    }
    if (origin) {
        window['bssOrigin'] = origin;
    }
    var tagging = descriptionConfig[elementType].tagging;
    if (tagging && resultData && layout) {
        layout.dxpTagging = tagging;
    }
    return data;
}
/**
 * Sorts products from resultData based on their position
 * @param resultData collected API response
 * @returns positions of sorted productIds by position as array
 */
export function sortByPosition(resultData) {
    var positions = sortBy(map(resultData, function (value, productId) {
        return {
            position: Number.parseInt(value.position, 10),
            productId: productId,
        };
    }), 'position');
    return positions.map(function (entry) { return entry.productId; });
}
/**
 * Prepares products data for the furter ui description processing
 * @param resultData - collected API response
 * @returns {PrepareProduct} object with products data for the further ui description processing
 */
export var prepareProducts = function (resultData, productType, standalone) {
    if (standalone === void 0) { standalone = false; }
    if (standalone)
        return {};
    var allProductPositions = sortByPosition(resultData);
    var productPositions = allProductPositions.filter(function (prodId) { return !resultData[prodId].error_code; });
    var onlyOneProductId = productPositions.length === 1 ? productPositions[0] : null;
    var defaultProductId = onlyOneProductId ||
        getCustomProductId(resultData, productType) ||
        getActiveProductId(productPositions, resultData);
    return { allProductPositions: allProductPositions, productPositions: productPositions, defaultProductId: defaultProductId };
};
/**
 * Gets productId by productType for widget in widget integration
 * @param resultData - collected API response
 * @param productType - collected API response
 */
var getCustomProductId = function (resultData, producType) {
    var _a;
    return (((_a = Object.values(resultData).find(function (data) { return data.productType === producType; })) === null || _a === void 0 ? void 0 : _a.productId) || null);
};
/**
 * Gets active/default productId
 * @param productPositions - list of product id's
 * @param resultData - collected API response
 */
var getActiveProductId = function (productPositions, resultData) {
    return productPositions.find(function (productId) {
        var _a = resultData[productId] || {}, isActive = _a.isActive, isDefault = _a.isDefault;
        return isActive === 'true' || isDefault === 'true';
    }) || null;
};
